export const translations = {
  en: {
    // Navigation
    'nav.schedule': 'Schedule',
    'nav.habits': 'Habits',
    'nav.routines': 'Routines',
    'nav.tasks': 'Tasks',
    'nav.projects': 'Projects',
    'nav.back': 'Back to Schedule',

    // Page Titles
    'habits.title': 'Habits',
    'habits.archived': 'Archived Habits',
    'projects.title': 'Projects',
    'projects.description': 'Manage and track your projects',
    'projects.new': 'New Project',
    'projects.edit': 'Edit Project',
    'projects.delete': 'Delete Project',
    'projects.status.active': 'Active',
    'projects.status.completed': 'Completed',
    'projects.status.archived': 'Archived',
    'actions.showArchived': 'Show Archived',
    'actions.showActive': 'Show Active',
    'New Habit': 'New Habit',

    // Routines
    'routines.title': 'Routines',
    'routines.new': 'New Routine',
    'routines.edit': 'Edit Routine',
    'routines.delete': 'Delete Routine',
    'routines.empty': 'No routines yet. Create your first routine to get started!',
    'routines.step.habit': 'Add Habit',
    'routines.step.break': 'Add Break',
    'routines.duration': 'Duration',
    'routines.total.xp': 'Total XP',
    'routines.total.time': 'Total Time',
    'routines.total.active': 'Active Time',
    'routines.total.activities': 'Activities',
    'routines.total.sequences': 'Sequences',

    // Settings
    'settings.title': 'Settings',
    'settings.profile': 'Profile',
    'settings.profile.description': 'Manage your personal information',
    'settings.theme': 'Theme',
    'settings.theme.description': 'Customize how the application looks',
    'settings.schedule': 'Schedule',
    'settings.schedule.description': 'Configure your schedule preferences',
    'settings.categories': 'Categories',
    'settings.categories.description': 'Manage your task and habit categories',
    'settings.cleanup': 'Data Cleanup',
    'settings.cleanup.description': 'Delete tasks and habits data',
    'settings.feedback': 'Feedback',
    'settings.feedback.description': 'Share your thoughts and suggestions',
    'settings.language': 'Language',
    'settings.language.description': 'Choose your preferred language',
    'settings.language.en': 'English',
    'settings.language.ar': 'العربية',
    'settings.direction': 'Text Direction',
    'settings.direction.description': 'Choose your preferred text direction',
    'settings.direction.ltr': 'Left to Right',
    'settings.direction.rtl': 'Right to Left',
    'settings.onboarding': 'App Tour',
    'settings.onboarding.description': 'Take a guided tour of the app features',

    // Common Actions
    'Today': 'Today',
    'All': 'All',
    'Level': 'Level',
    'Total Points': 'Total Points',
    'No activity today': 'No activity today',
    'View All': 'View All'
  },
  ar: {
    // Navigation
    'nav.schedule': 'الجدول',
    'nav.habits': 'العادات',
    'nav.routines': 'الروتين',
    'nav.tasks': 'المهام',
    'nav.projects': 'المشاريع',
    'nav.back': 'العودة إلى الجدول',

    // Page Titles
    'habits.title': 'العادات',
    'habits.archived': 'العادات المؤرشفة',
    'projects.title': 'المشاريع',
    'projects.description': 'إدارة وتتبع مشاريعك',
    'projects.new': 'مشروع جديد',
    'projects.edit': 'تعديل المشروع',
    'projects.delete': 'حذف المشروع',
    'projects.status.active': 'نشط',
    'projects.status.completed': 'مكتمل',
    'projects.status.archived': 'مؤرشف',
    'actions.showArchived': 'عرض المؤرشف',
    'actions.showActive': 'عرض النشط',
    'New Habit': 'عادة جديدة',

    // Routines
    'routines.title': 'الروتين',
    'routines.new': 'روتين جديد',
    'routines.edit': 'تعديل الروتين',
    'routines.delete': 'حذف الروتين',
    'routines.empty': 'لا يوجد روتين بعد. أنشئ أول روتين للبدء!',
    'routines.step.habit': 'إضافة عادة',
    'routines.step.break': 'إضافة استراحة',
    'routines.duration': 'المدة',
    'routines.total.xp': 'مجموع النقاط',
    'routines.total.time': 'الوقت الكلي',
    'routines.total.active': 'وقت النشاط',
    'routines.total.activities': 'الأنشطة',
    'routines.total.sequences': 'التسلسلات',

    // Settings
    'settings.title': 'الإعدادات',
    'settings.profile': 'الملف الشخصي',
    'settings.profile.description': 'إدارة معلوماتك الشخصية',
    'settings.theme': 'المظهر',
    'settings.theme.description': 'تخصيص مظهر التطبيق',
    'settings.schedule': 'الجدول',
    'settings.schedule.description': 'تكوين تفضيلات الجدول',
    'settings.categories': 'الفئات',
    'settings.categories.description': 'إدارة فئات المهام والعادات',
    'settings.cleanup': 'تنظيف البيانات',
    'settings.cleanup.description': 'حذف بيانات المهام والعادات',
    'settings.feedback': 'التعليقات',
    'settings.feedback.description': 'شارك أفكارك واقتراحاتك',
    'settings.language': 'اللغة',
    'settings.language.description': 'اختر لغتك المفضلة',
    'settings.language.en': 'English',
    'settings.language.ar': 'العربية',
    'settings.direction': 'اتجاه النص',
    'settings.direction.description': 'اختر اتجاه النص المفضل لديك',
    'settings.direction.ltr': 'من اليسار إلى اليمين',
    'settings.direction.rtl': 'من اليمين إلى اليسار',
    'settings.onboarding': 'جولة التطبيق',
    'settings.onboarding.description': 'خذ جولة إرشادية لميزات التطبيق',

    // Common Actions
    'Today': 'اليوم',
    'All': 'الكل',
    'Level': 'المستوى',
    'Total Points': 'مجموع النقاط',
    'No activity today': 'لا يوجد نشاط اليوم',
    'View All': 'عرض الكل'
  }
};